import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'
import clsx from 'clsx'

import { Container } from '@/components/Container'
import {
  GitHubIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
} from '@/components/SocialIcons'
import portraitImage from '@/images/portrait1.jpg'
import {FormattedMessage} from "react-intl";

function SocialLink({ className, href, children, icon: Icon }) {
  return (
    <li className={clsx(className, 'flex')}>
      <Link
        href={href}
        className="group flex text-sm font-medium text-zinc-800 transition hover:text-teal-500 dark:text-zinc-200 dark:hover:text-teal-500"
      >
        <Icon className="h-6 w-6 flex-none fill-zinc-500 transition group-hover:fill-teal-500" />
        <span className="ml-4">{children}</span>
      </Link>
    </li>
  )
}

function MailIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        d="M6 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6Zm.245 2.187a.75.75 0 0 0-.99 1.126l6.25 5.5a.75.75 0 0 0 .99 0l6.25-5.5a.75.75 0 0 0-.99-1.126L12 12.251 6.245 7.187Z"
      />
    </svg>
  )
}

export default function About() {
  return (
    <>
      <Head>
        <title>About - Rahimi Diallo</title>
        <meta
          name="description"
          content="I’m Rahimi Diallo. I live in Malaysia."
        />
      </Head>
      <Container className="mt-16 sm:mt-32">
        <div className="grid grid-cols-1 gap-y-16 lg:grid-cols-2 lg:grid-rows-[auto_1fr] lg:gap-y-12">
          <div className="lg:pl-20">
            <div className="max-w-xs px-2.5 lg:max-w-none">
              <Image
                src={portraitImage}
                alt=""
                sizes="(min-width: 1024px) 32rem, 20rem"
                className="aspect-square rotate-3 rounded-2xl bg-zinc-100 object-cover dark:bg-zinc-800"
              />
            </div>
          </div>
          <div className="lg:order-first lg:row-span-2">
            <h1 className="text-4xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-5xl">
              <FormattedMessage id="about.page.title.h1.slice1" />{' '}
              <span className="text-teal-500">Rahimi Diallo</span>, {' '}
              <FormattedMessage id="about.page.title.h1.slice2" />
            </h1>
            <div className="mt-6 space-y-7 text-base text-zinc-600 dark:text-zinc-400">
              <p>
                <FormattedMessage id="about.page.title.p.slice1" />
              </p>
              <p>
                <FormattedMessage id="about.page.title.p.slice2" />
              </p>
              <p>
                <FormattedMessage id="about.page.title.p.slice3" />
              </p>
              <p>
                <FormattedMessage id="about.page.title.p.slice4" />
              </p>
              <p>
                <FormattedMessage id="about.page.title.p.slice5" />
              </p>
            </div>
          </div>
          <div className="lg:pl-20">
            <ul role="list">
              <SocialLink
                href="https://twitter.com/tard91"
                target="_blank"
                icon={TwitterIcon}
              >
                <FormattedMessage id="about.page.sm.twitter" />
              </SocialLink>
              <SocialLink
                href="https://www.instagram.com/rahimi916"
                target="_blank"
                icon={InstagramIcon}
                className="mt-4"
              >
                <FormattedMessage id="about.page.sm.instagram" />
              </SocialLink>
              <SocialLink
                href="https://github.com/tard916"
                target="_blank"
                icon={GitHubIcon}
                className="mt-4"
              >
                <FormattedMessage id="about.page.sm.gitHub" />
              </SocialLink>
              <SocialLink
                href="https://www.linkedin.com/in/thierno-abdoul-rahim-diallo"
                target="_blank"
                icon={LinkedInIcon}
                className="mt-4"
              >
                <FormattedMessage id="about.page.sm.linkedIn" />
              </SocialLink>
              <SocialLink
                href="mailto:rahimi.diallo@224tech.com"
                icon={MailIcon}
                className="mt-8 border-t border-zinc-100 pt-8 dark:border-zinc-700/40"
              >
                rahimi.diallo@224tech.com
              </SocialLink>
            </ul>
          </div>
        </div>
      </Container>
    </>
  )
}
